import { LayoutAuth, LayoutDefault, RouteWrapper } from '@/components/layouts'

export const publicRoute = [
  {
    path: '*',
    component: () => import('@/views/error/NotFound.vue'),
  },
  {
    path: '/',
    component: LayoutDefault,
    meta: {
      title: 'top_index',
    },
    children: [
      {
        path: '',
        name: 'TopIndex',
        meta: {
          title: 'top_index',
        },
        component: () => import('@/views/top/Index.vue'),
      },
      {
        path: '/company',
        component: RouteWrapper,
        meta: {
          title: 'company_index',
          icon: 'list_alt',
        },
        children: [
          {
            path: '',
            name: 'CompanyIndex',
            meta: {
              title: 'company_index',
              icon: 'list_alt',
            },
            component: () => import('@/views/company/Index.vue'),
          },
          {
            path: '/company/:company_id',
            name: 'CompanyDetail',
            meta: {
              title: 'company_detail',
              icon: 'list_alt',
            },
            component: () => import('@/views/company/Detail.vue'),
          },
        ],
      },
      {
        path: '/finance',
        name: 'FinanceIndex',
        meta: {
          title: 'finance_index',
        },
        component: () => import('@/views/finance/Index.vue'),
      },
      {
        path: '/finance2',
        name: 'FinanceIndex',
        meta: {
          title: 'finance_index',
        },
        component: () => import('@/views/finance2/Index.vue'),
      },
      {
        path: '/market',
        name: 'MarketIndex',
        meta: {
          title: 'market_index',
        },
        component: () => import('@/views/market/Index.vue'),
      },
      {
        path: '/volumespike',
        name: 'VolumespikeIndex',
        meta: {
          title: 'volumespike_index',
        },
        component: () => import('@/views/volumespike/Index.vue'),
      },
      {
        path: '/yearhigh',
        name: 'YearhighIndex',
        meta: {
          title: 'yearhigh_index',
        },
        component: () => import('@/views/yearhigh/Index.vue'),
      },
      {
        path: '/sector',
        name: 'SectorIndex',
        meta: {
          title: 'sector_index',
        },
        component: () => import('@/views/sector/Index.vue'),
      },
      {
        path: '/article',
        component: RouteWrapper,
        meta: {
          title: 'article_index',
          icon: 'list_alt',
        },
        children: [
          {
            path: '',
            name: 'ArticleIndex',
            meta: {
              title: 'article_index',
              icon: 'list_alt',
            },
            component: () => import('@/views/article/Index.vue'),
          },
          {
            path: '/article/create',
            name: 'ArticleCreate',
            meta: {
              title: 'article_create',
              icon: 'edit',
            },
            component: () => import('@/views/article/Create.vue'),
          },
          {
            path: '/article/:article_id',
            name: 'ArticleDetail',
            meta: {
              title: 'article_detail',
              icon: 'list_alt',
            },
            component: () => import('@/views/article/Detail.vue'),
          },
        ],
      },
      {
        path: '/topic',
        component: RouteWrapper,
        meta: {
          title: 'topic_index',
          icon: 'list_alt',
        },
        redirect: '/topic/basic',
        children: [
          {
            path: '/topic/basic',
            name: 'TopicBasic',
            meta: {
              title: 'topic_basic',
              icon: 'list_alt',
            },
            component: () => import('@/views/topic/Basic.vue'),
          },
          {
            path: '/topic/advanced',
            name: 'TopicAdvanced',
            meta: {
              title: 'topic_advanced',
              icon: 'list_alt',
            },
            component: () => import('@/views/topic/Advanced.vue'),
          },
        ],
      },
    ],
  },

  {
    path: '/login/index',
    component: LayoutAuth,
    redirect: '/login',
    hidden: true,
    children: [
      {
        path: '/login',
        name: 'LoginIndex',
        meta: { title: 'login_index' },
        component: () => import('@/views/login/Index.vue'),
      },
    ],
  },

  {
    path: '/logout/index',
    component: LayoutAuth,
    redirect: '/logout',
    hidden: true,
    children: [
      {
        path: '/logout',
        name: 'LogoutIndex',
        meta: { title: 'logout_index' },
        component: () => import('@/views/logout/Index.vue'),
      },
    ],
  },

  {
    path: '/403',
    name: 'Forbidden',
    meta: {
      title: 'error_403',
      hiddenInMenu: true,
    },
    component: () => import('@/views/error/Deny.vue'),
  },

  {
    path: '/404',
    name: '404',
    meta: {
      title: 'error_404',
    },
    component: () => import('@/views/error/NotFound.vue'),
  },

  {
    path: '/500',
    name: '500',
    meta: {
      title: 'error_500',
    },
    component: () => import('@/views/error/Error.vue'),
  },
]

export const protectedRoute = [
  {
    path: '/top',
    component: LayoutDefault,
    redirect: '/',
    meta: {
      title: 'top_index',
    },
    children: [],
  },
]
